export default "__VITE_ASSET__DESunC1x__"